var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radios"},_vm._l((_vm.list),function(item,index){return _c('radio-item',{key:item.id,attrs:{"item":item,"index":index,"slug":_vm.slug,"checked":_vm.value[_vm.slug].list[0].value},on:{"select":_vm.selected}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }